import type {
  RequestFeedbackLoop,
  RequestFeedbackLoopOptions,
} from '@wix/feedback-loop-structure';

type RequestFeedbackOptions = Omit<RequestFeedbackLoopOptions, 'debug'>;

export type RequestFeedback = RequestFeedbackLoop<RequestFeedbackOptions>;
